export default __webpack_public_path__ + "static/media/logout-blue.9b81efe9.svg";